"use client";

import { passkeyClient } from "@better-auth/passkey/client";
import { adminClient, inferAdditionalFields, magicLinkClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

import type { auth } from "./auth";

/**
 * The browser half of Better Auth.
 *
 * `auth` is imported for its type only — the import is erased at compile
 * time, so the server config (and the secrets it reads) never reaches the
 * bundle. It buys `session.user.plan` and `session.user.role` being typed
 * here rather than cast at every call site.
 */
export const authClient = createAuthClient({
  plugins: [
    inferAdditionalFields<typeof auth>(),
    magicLinkClient(),
    passkeyClient(),
    adminClient(),
  ],
});

export const { signIn, signUp, signOut, useSession } = authClient;
